import { createSelector } from 'reselect';

import { StringStateDictionary } from '../reducers/utils/state-manager';

export type ScheduledMessageFilesState = {
  scheduledMessageFilesById: { [scheduledMessageId: number]: ScheduledMessageFile };
  scheduledMessageFilesStateByEmployeeGroupId: StringStateDictionary;
};

// While we *could* make the redux state be a mapping of employeeGroupId/orgId --> ScheduledMessageFile, there are future cases where
// the state can be mapped to surveys, applicantTriggeredCommunications, and/or scheduledTextMessages. As such, the state here will be
// agnostic to a specific mapping and will instead have separate selectors for different retrieval methods.
type State = { scheduledMessageFiles: ScheduledMessageFilesState };

const scheduledMessageFilesByEmployeeGroupIdSelector = (state: State) =>
  state.scheduledMessageFiles.scheduledMessageFilesById;
export const scheduledMessageFilesForEmployeeGroupIdSelector = createSelector(
  [
    scheduledMessageFilesByEmployeeGroupIdSelector,
    (_state: State, employeeGroupId: number | string, orgId: number) => ({
      employeeGroupId,
      orgId,
    }),
  ],
  (scheduledMessageFiles, ids) =>
    Object.values(scheduledMessageFiles).filter(
      (smf) =>
        smf.OrganizationFile?.orgId === ids.orgId &&
        ((typeof ids.employeeGroupId === 'number' &&
          smf.Announcement?.EmployeeGroup &&
          smf.Announcement?.EmployeeGroup?.employeeGroupId === ids.employeeGroupId) ||
          (typeof ids.employeeGroupId === 'string' && smf.Announcement?.EmployeeGroup === null)),
    ),
);

const scheduledMessageFilesStateByEmployeeGroupIdSelector = (state: State) =>
  state.scheduledMessageFiles.scheduledMessageFilesStateByEmployeeGroupId;
export const scheduledMessageFilesStateForEmployeeGroupIdSelector = createSelector(
  [
    scheduledMessageFilesStateByEmployeeGroupIdSelector,
    (_state: State, employeeGroupId: number | string) => employeeGroupId,
  ],
  (scheduledMessageFilesStateByEmployeeGroupId, employeeGroupId) =>
    scheduledMessageFilesStateByEmployeeGroupId[employeeGroupId],
);
